import "@/utils/polyfills";
import App from "@/app";
import reportWebVitals from "@/reportWebVitals";
import "@/assets/styles/safe-area.css";
import * as Sentry from "@sentry/react";
import { isFromAppBundle } from "@/utils/sentry";
import ReactDOM from "react-dom/client";

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);

Sentry.init({
  dsn: process.env.REACT_APP_SENTRY_DSN,
  integrations: [Sentry.browserTracingIntegration(), Sentry.replayIntegration()],
  // Tracing
  tracesSampleRate: 0.5, //  Capture 50% of the transactions

  autoSessionTracking: true, // Automatically track sessions

  // Session Replay
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  release: process.env.REACT_APP_RELEASE || "irohana@1.0.0",

  // Ignore errors from scripts injected by FB in-app browser (iabjs://)
  denyUrls: [/^iabjs:\/\//i],

  beforeSend: (event) => (isFromAppBundle(event) ? event : null),
});

root.render(<App />);

reportWebVitals();
